export default "__VITE_ASSET__d9a65c08__"